const API_KEY = "AIzaSyCUtHkJVJC7N4H6bMmG82Y3CF_fRRmTK4k";
export const yt_api =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&regionCode=IN&maxResults=50&key=" +
  API_KEY;

export const yt_suggest_api =
  "https://suggestqueries.google.com/complete/search?client=youtube&ds=yt&client=chrome&q=";

export const yt_api1 =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&regionCode=IN&maxResults=10&key=" +
  API_KEY;

export const yt_search_api =
  "https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=15&type=video&key=AIzaSyCUtHkJVJC7N4H6bMmG82Y3CF_fRRmTK4k&q=";

export const yt_channel_api =
  "https://www.googleapis.com/youtube/v3/channels?part=snippet&id=";
export const yt_channel_api2 = "&key=AIzaSyCUtHkJVJC7N4H6bMmG82Y3CF_fRRmTK4k";
// https://www.googleapis.com/youtube/v3/channels?part=snippet&id=&key=AIzaSyCUtHkJVJC7N4H6bMmG82Y3CF_fRRmTK4k
